export const PushNotificationPanelTestIds = {
  BACK_BUTTON: 'push-notifications.back-button',
  MARK_ALL_READ_BUTTON: 'push-notifications.mark-all-read-button',
};
